<template>
  <div class="containerPage">
    <form method="POST" :action="route">
      <input type="hidden" name="_token" :value="csrf">
      <button type="submit" class="btnAddPage" @click.prevent="openModal">
        <span>+</span>
      </button>
    </form>

    <nav class="listPage">
      <ul id="page_draggable" :class="'drag-'+elem">
          <li v-for="item in listPage" class="listPage_items" :data-id="item.id" :class="{'is-active' : pageActive !== item.online}">
              <a :href="'/admin/'+elem+'/setinline/'+item.id" class="btn_active_page" @click.prevent="setActive(item)"></a>
              <span v-if="elem === 'pages'" class="listPage_items_name">{{item.name}}</span>
              <span v-else class="listPage_items_name">{{item.title}}</span>
              <span class="listPage_items_ctrl">
                <a v-if="elem === 'pages'" :href="'/admin/pages/edit/'+ item.id" class="listPage_items_btn fas fa-cog"> </a>
                <a v-if="elem==='pages'" :href="'/admin/pages/'+ item.id" class="listPage_items_btn listPage_items_btn-strong fas fa-edit"> </a>
                <a v-else :href="'/admin/posts/edit/'+ item.id" class="listPage_items_btn listPage_items_btn-strong fas fa-edit"> </a>
                <a :href="'/admin/'+elem+'/delete/'+ item.id" class="listPage_items_btn listPage_items_btn-danger fas fa-trash"
                   @click.prevent="deleteItem"> </a>
              </span>
              <span class="listPage_items_children" v-if="typeof item.children !== 'undefined' && item.children.length > 0">
                <ul>
                  <li class="listPage_items_children_items" :data-id="child.id" v-for="child in item.children">
                      <a :href="'/admin/pages/setinline/'+child.id" class="btn_active_page"></a>
                      <span class="listPage_items_name">{{child.name}}</span>
                      <span class="listPage_items_ctrl">
                          <a :href="'/admin/pages/edit/'+ child.id" class="listPage_items_btn fas fa-cog"> </a>
                          <a :href="'/admin/pages/'+ child.id" class="listPage_items_btn listPage_items_btn-strong fas fa-edit"> </a>
                          <a :href="'/admin/pages/delete/'+ child.id" class="listPage_items_btn listPage_items_btn-danger fas fa-trash"
                             @click.prevent="deleteItem"></a>
                      </span>
                  </li>
                </ul>
            </span>
          </li>
      </ul>
    </nav>

    <transition name="fade">
      <Modal v-if="visible" :data-visible="visible"
             @click.native.self="closeModal"
             @close="closeModal"
             :route="route" :csrf="csrf"
             :elem="elem"
            :data-list-page="listPage">
      </Modal>
    </transition>
  </div>
</template>

<script>
  import Modal from './ModalForCreateComponent'
  import Swal from 'sweetalert2'
  window.axios = require('axios')
  export default {
    components: { Modal },
    props: {
      route: String,
      csrf: String,
      elem: String,
      dataListPage: Array
    },
    data() {
      return {
        visible: false,
        listPage: this.dataListPage,
        pageActive: 0
      }
    },
    methods: {
      openModal: function(){
        this.visible = true
      },
      closeModal: function(e){
        this.visible = false
      },
      deleteItem: function (event) {
        const url = event.currentTarget.href
        Swal.fire({
          title: 'Êtes vous sûr?',
          text: 'Cette action est irreverisble',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#4A74C7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui, je supprime!',
          cancelButtonText: 'Annuler'
        }).then((result) => {
          if (result.value) {
            axios.get(url, {
              params: {isAjax : true}
            }).then(({data}) => {
                this.listPage = this.listPage.filter(function(obj) {
                  if ((obj.children) && obj.children !== 'undefined' && obj.children.length > 0 ) {
                    obj.children = obj.children.filter(function(child) {
                      return child.id !== data.id
                    })
                  }
                  return obj.id !== data.id
                })
            })
          }
        })
      },
      setActive(item) {
        const url = event.currentTarget.href
        axios.get(url, {
          params: {isAjax : true}
        }).then(({data}) => {
            this.$set(item, 'online', data.online)
        })
      }
    }
  }
</script>
<style>
  .fade-enter-active, .fade-leave-active{
    transition: opacity .5s;
  }
  .modal-js {
    transition: transform .5s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;
  }

  .fade-enter .modal-js {
    transform: translateY(30px);
  }

</style>
